import { Box, Heading, ThemeColorVariable, ThemeSpaceVariable } from "@caspeco/casper-ui-library";
import { AvailableTimesSection } from "types/available-times";
import { PaymentRule } from "types/payment";
import { TimeSlot } from "types/time-slot";
import { WebRuleType } from "types/web-rule-type";
import { useCategorizedWebRules } from "hooks/use-categorized-web-rules";
import { PageType } from "logger/page-tracking";
import { usePageTracking } from "logger/use-page-tracking";
import TimeSet from "./time-set/time-set";
import SimpleWebRule from "../select-activity/simple-web-rule-title/simple-web-rule";

interface ISectionOfAvailableTimes {
    expanded?: boolean;
    availableTimesSection: AvailableTimesSection;
    selectedTime?: TimeSlot;
    onTimeClickOverride?: (time: TimeSlot) => void;
    isEditBookingMode?: boolean;
}

const SectionOfAvailableTimes = (props: ISectionOfAvailableTimes) => {
    // Use the composite hook to get categorized and filtered WebRules
    const { activityOrderedSequence } = useCategorizedWebRules(
        props.availableTimesSection.timeSets
    );

    const finalOrdered = activityOrderedSequence.filter((rule) => {
        if (props.isEditBookingMode) {
            if (rule.type === WebRuleType.Interactive) {
                if (rule.webRule.menuGuid || rule.webRule.paymentRule !== PaymentRule.NoPayment) {
                    return false;
                }
            }
        }
        return true;
    });

    // Track activity time selection (normal flow)
    usePageTracking({
        pageName: "SelectActivityTime",
        pageType: PageType.Page,
        autoTrack: finalOrdered.length > 0,
        metadata: {
            activityName: props.availableTimesSection.name,
            activityId: props.availableTimesSection.id.toString(),
            isEditMode: props.isEditBookingMode || false,
            timeSlotCount: finalOrdered.reduce((acc, item) => {
                return item.type === WebRuleType.Interactive
                    ? acc + item.webRule.times.length
                    : acc;
            }, 0),
        },
    });

    if (finalOrdered.length === 0) {
        return null;
    }

    return (
        <>
            {!props.selectedTime && (
                <Heading
                    as="h5"
                    fontWeight="500"
                    flex="1"
                    textAlign="left"
                    mb={ThemeSpaceVariable.Medium}
                    color={ThemeColorVariable.OnBackgroundHeader}
                >
                    {props.availableTimesSection.name}
                </Heading>
            )}
            {finalOrdered.map((item, index) => {
                if (item.type === WebRuleType.Interactive) {
                    return (
                        <TimeSet
                            key={`timeSet${item.webRule.id}-${index}`}
                            timeSet={item.webRule}
                            selectedTime={props.selectedTime}
                            onTimeClickOverride={props.onTimeClickOverride}
                        />
                    );
                } else {
                    return (
                        <Box
                            key={`commentOnly${item.webRule.id}-${index}`}
                            mb={ThemeSpaceVariable.Medium}
                        >
                            <SimpleWebRule webRule={item.webRule} />
                        </Box>
                    );
                }
            })}
        </>
    );
};

export default SectionOfAvailableTimes;
